<template>
  <div class="md-appbar-items">
    <slot></slot>
  </div>
</template>

<script>
export default {
    name: "BsAppbarItems"
}
</script>

<style scoped>

</style>
